/**
 * Planbord-legenda (Epic C-3 — Planbord & indelen, Story C-3.3, UX-C1)
 *
 * Hergebruikt de aanwezigheids-statussen (zelfde constantes als
 * `AanwezigheidLegend.tsx`) + de planbord-specifieke items: "gekleurde cel
 * met accentbalk = ingedeeld", amber driehoek = kwalificatie ontbreekt,
 * rood = conflict.
 */

import { KANTOOR_BG, KANTOOR_ACCENT, THUIS_BG, THUIS_ACCENT, VRIJ_COLOR, pastelTint, readableInk, LEAVE_PASTEL_AMOUNT, ZIEK_STRIPE_LIGHT, ZIEK_STRIPE_DARK, ZIEK_TEXT, HOLIDAY_BG, HOLIDAY_BORDER, HOLIDAY_COLOR } from '../../aanwezigheid/components/aanwezigheidVisuals';

export function PlanningLegend() {
  return (
    <div data-testid="planning-legend" className="flex flex-wrap items-center gap-4 px-4 py-3 bg-white border-t border-[#E2E8F0] text-xs text-[#1E293B]">
      <div className="flex items-center gap-1.5">
        <span className="inline-block w-3 h-3 rounded-sm" style={{ backgroundColor: KANTOOR_BG, boxShadow: `inset 2px 0 0 ${KANTOOR_ACCENT}` }} />
        <span>Kantoor (beschikbaar)</span>
      </div>
      <div className="flex items-center gap-1.5">
        <span className="inline-block w-3 h-3 rounded-sm" style={{ backgroundColor: THUIS_BG, boxShadow: `inset 2px 0 0 ${THUIS_ACCENT}` }} />
        <span>Thuis (beschikbaar)</span>
      </div>
      <div className="flex items-center gap-1.5">
        <span
          className="inline-block w-3 h-3 rounded-sm"
          style={{ backgroundColor: pastelTint(VRIJ_COLOR, LEAVE_PASTEL_AMOUNT), boxShadow: `inset 2px 0 0 #334155` }}
        />
        <span>Gekleurde cel met accentbalk = ingedeeld op taak</span>
      </div>
      <div className="flex items-center gap-1.5">
        <span
          className="inline-block w-3 h-3 rounded-sm border border-[#E2E8F0]"
          style={{ backgroundImage: `repeating-linear-gradient(45deg, ${ZIEK_STRIPE_LIGHT}, ${ZIEK_STRIPE_LIGHT} 2px, ${ZIEK_STRIPE_DARK} 2px, ${ZIEK_STRIPE_DARK} 4px)` }}
        />
        <span style={{ color: ZIEK_TEXT }}>Ziek</span>
      </div>
      <div className="flex items-center gap-1.5">
        <span className="inline-block w-3 h-3 rounded-sm border border-[#E2E8F0]" style={{ backgroundColor: pastelTint(VRIJ_COLOR, LEAVE_PASTEL_AMOUNT) }} />
        <span style={{ color: readableInk(VRIJ_COLOR) }}>Vrij</span>
      </div>
      <div className="flex items-center gap-1.5">
        <span className="inline-block w-3 h-3 rounded-sm" style={{ backgroundColor: HOLIDAY_BG, border: `1px solid ${HOLIDAY_BORDER}` }} />
        <span style={{ color: HOLIDAY_COLOR }}>Feestdag</span>
      </div>
      <div className="flex items-center gap-1.5">
        <span className="inline-block w-3 h-3 rounded-sm bg-[#F3F4F6] border border-[#E2E8F0]" />
        <span className="text-gray-500">Weekend</span>
      </div>
      <div className="flex items-center gap-1.5">
        <span className="inline-block w-3 h-3 rounded-sm border border-[#E2E8F0] bg-white" />
        <span>(leeg) = niet ingeroosterd</span>
      </div>
      <div className="flex items-center gap-1.5">
        <span aria-hidden="true" className="text-[10px] font-bold" style={{ color: '#B45309' }}>
          &#9650;
        </span>
        <span>Amber driehoek = kwalificatie ontbreekt</span>
      </div>
      <div className="flex items-center gap-1.5">
        <span aria-hidden="true" className="inline-block w-3 h-3 rounded-sm border-2" style={{ borderColor: '#D64545' }} />
        <span>Rood = conflict</span>
      </div>
    </div>
  );
}
